export const WALLET_CONNECTED = "WALLET_CONNECTED";
export const WALLET_DISCONNECTED = "WALLET_DISCONNECTED";
export const WALLET_BALANCE_DATA = "WALLET_BALANCE_DATA";
export const WALLET_ADDRESS_CHANGED = "WALLET_ADDRESS_CHANGED";
export const WALLET_CHAIN_CHANGED = "WALLET_CHAIN_CHANGED";
export const WALLET_OPENED = "WALLET_OPENED";

export const NETWORK_VALID = "NETWORK_VALID";
export const NETWORK_INVALID = "NETWORK_INVALID";

export const SET_CHAIN_DATA = "SET_CHAIN_DATA";

export const GET_ASSETS = "GET_ASSETS";

export const SET_THEME = "SET_THEME";
